var _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatIsAnHraShadow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 41,
    viewBox: "0 0 692 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346,
    cy: 20.5,
    rx: 346,
    ry: 20.5,
    fill: "#C8DAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatIsAnHraShadow);
export default __webpack_public_path__ + "static/media/whatIsAnHRAShadow.fecbc2d579e56df44820b63bbdef42d4.svg";
export { ForwardRef as ReactComponent };